import type { ClockPort, IdGeneratorPort } from './ports'

function createRandomId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  return `id_${Math.random().toString(36).slice(2, 10)}`
}

function nowTimestamp(): string {
  return new Date().toISOString()
}

export const systemClock: ClockPort = {
  now: nowTimestamp,
}

export const randomIdGenerator: IdGeneratorPort = {
  generateId: createRandomId,
}
